import React from "react";
import { useTranslation } from "react-i18next";

import { getMonthsTexts } from "../../utils";
import { Props } from "./types";
import styles from "./styles.scss";

function Month({ month }: Props) {
  const { t } = useTranslation();
  const months = getMonthsTexts(t);
  const firstDt = month[0];

  return (
    <p className={styles.month}>
      {months[firstDt.month - 1]}{" "}
      <span className={styles.year}>{firstDt.year}</span>
    </p>
  );
}

export { Month };
